import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { BaseRespone, PaginationResult } from "src/app/models/common.response";
import { GenericContentService } from "./generic-content.service";
import { IGenericContent } from "./igeneric-content";

@Injectable({
    providedIn: 'root'
})
export class GenericContentResolver implements Resolve<any> {
    /**
     * Constructor
     */
    constructor(private _genericContentService: GenericContentService) {
    }

    /**
     * Resolver
     *
     * @param route
     * @param state
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<BaseRespone<{ pagination: PaginationResult, genericContentDetails: IGenericContent[] }>> {
        var data = {
            pageNumber: 0,
            pageSize: 100,
        };
        return this._genericContentService.getAllGenericContent(data);
    }
}